import defaultProfileImg from "@/assets/images/default-profile.webp";

export const getProfilePictureThumbnail = (
  uid: string | undefined,
  size: "small" | "medium" | "large" = "small"
) => {
  if (!uid) {
    return defaultProfileImg.uri;
  }
  // New structure: profile-pictures/{uid}/thumbs/original_200x200.webp
  // We are assuming the original file name is 'original' and the resize extension creates this structure.
  // We also assume 200x200 is the target size for now.
  const path = `profile-pictures/${uid}/thumbs/original_200x200.webp`;
  const encodedPath = encodeURIComponent(path);
  return `https://firebasestorage.googleapis.com/v0/b/${process.env.EXPO_PUBLIC_FIREBASE_STORAGE_BUCKET}/o/${encodedPath}?alt=media`;
};
